import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/shipment_refund_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .submit_refund': 'submitRefund',
  },

  context() {
    return {
      id: this.model.get('id'),
      tracking_code: this.model.get('tracking_code'),
    };
  },

  submitRefund(event) {
    event.preventDefault();
    this.model.submitForRefund();
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/shipment_refund_modal.js